import { useMutation, useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { RemoteCouponsRepo } from './CouponsRepo';
import CreateCouponsRq from '@domain/rq/coupons/CreateCouponsRq';
import RegisteredCouponListVO from '@domain/vo/coupons/RegisteredCouponVO';

const remoteCouponsRepo = new RemoteCouponsRepo();

const keys = ['coupons'];

const createCoupons = async (rq: CreateCouponsRq) => {
  const { data } = await remoteCouponsRepo.createCoupons(rq);
  return data;
};

const fetchCouponCheck = async (couponCode: string) => {
  const { data } = await remoteCouponsRepo.fetchCouponCheck(couponCode);
  return data;
};

const registerCoupons = async (couponCode: string) => {
  const { data } = await remoteCouponsRepo.registerCoupons(couponCode);
  return data;
};

const fetchCouponsRegistered = async () => {
  const { data } = await remoteCouponsRepo.fetchCouponsRegistered();
  return new RegisteredCouponListVO(data);
};

export function useCreateCoupons() {
  return useMutation((rq: CreateCouponsRq) => createCoupons(rq));
}

export function useCouponCheck(onError?: (e: AxiosError) => void) {
  return useMutation((couponCode: string) => fetchCouponCheck(couponCode), { onError });
}

export function useRegisterCoupons(onError?: (e: AxiosError) => void) {
  return useMutation((couponCode: string) => registerCoupons(couponCode), { onError });
}

export function useCouponsRegistered() {
  return useQuery([...keys, 'registered'], () => fetchCouponsRegistered());
}
